<template>
  <div class="document-tree-item-template p-0 h-fit">
    <div
      class="flex items-center pl-1"
      @click.stop="toggleSwitchOpen()"
      :class="{
        'tree-item-selected': isSelected(folder.path),
      }"
    >
      <div class="tree-item flex">
        <transition name="rotate">
          <feather-icon
            icon="ChevronRightIcon"
            class="collapse-icon  cursor-pointer "
            :class="isOpen ? 'open-tree' : 'collapse-tree'"
            svgClasses="h-6 w-4"
          ></feather-icon>
        </transition>
      </div>

      <div
        class="w-full items-center cursor-pointer tree-item"
        @click.stop="toggleTreeSelect()"
      >
        <vx-tooltip :text="folder.name">
          <div class="flex pl-1 py-1">
            <document-icon type="folder" svgClasses="w-6 h-6"></document-icon>
            <div
              class="
                w-10/12
                overflow-hidden
                mx-3
                text-base
                document-name-tooltip
                truncate
                ...
              "
            >
              {{ folder.name }}
            </div>
          </div>
        </vx-tooltip>
      </div>
    </div>
    <transition name="expand">
      <div v-show="isOpen">
        <slot name="child"></slot>
      </div>
    </transition>
  </div>
</template>

<script>
import DocumentIcon from "../icon/DocumentIcon";

export default {
  name: "TreeTemplate",
  props: {
    folder: { type: Object },
    switchOpenMethod: { type: Function },
    selectedMethod: { type: Function },
    isSelected: { type: Function },
  },
  components: { DocumentIcon },
  data () {
    return {
      scrollSettings: {
        maxScrollbarLength: 20,
      },
    }
  },
  computed: {
    isOpen() {
      return this.folder.isOpen
    }
  },
  methods: {
    toggleSwitchOpen () {
      this.switchOpenMethod(this.folder);
    },
    toggleTreeSelect () {
      try {
        this.selectedMethod(this.folder);
      } catch (error) {
        this.$vs.notify({
          title: "書類の取得に失敗しました",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-square"
        });
      }
    },
  },
  mounted () {
  },
  created () {
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
@import "@/assets/scss/aisea/document-manager.scss";
</style>